import { AdvancedSearch } from '../../features/search/AdvancedSearch';

/** Advanced search — served at both /search and /advanced-search. */
export default function SearchPage() {
  return <AdvancedSearch />;
}
